import React, {useState} from 'react'
export default function ABC(){
    const [ABC, setABC] = useState('')
    const [DEF, setDEF] = useState('')
    const [GHI, setGHI] = useState('')
    function MNO(date, options, separator) {
        function format(option) {
            let PQR = new Intl.DateTimeFormat('en', option)
            return PQR.format(date)
        }
        return options.map(format).join(separator)
    } 
    const JKL = MNO(new Date(), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
    const STU = ()=>{
        setDEF('')
        setGHI('')
        if(ABC==''){
            setDEF('Please input due date')
        }else{
            setGHI('You have successfully submited.')
        }
    }
   return (
      <div className='flex flex-col'>
        <div className='text-xs mb-2'>· requirement field<br/>
        · past date can not be selected</div>
        <label className='text-xs'>Due date*</label>
        <input type='date' className={`${DEF!=''?'border-red-700':'border-gray-900'} text-xs border w-fit mr-1`}
        min={JKL} onChange={e=> setABC(e.target.value)} />
        <div className='flex flex-col mb-2'><button className='primary-btn text-xs w-fit mt-1' onClick={STU} disabled={!(ABC.length>0)}>Submit</button>
        <span className='text-xs'>{GHI}</span>
        </div>
      </div>
    )
}